module.exports = __webpack_public_path__ + "img/illustration_2.c4f2f28a.svg";